import * as axios from "axios";
import config from "./config/config";


let cmAPI = axios.create({
    baseURL: config.api.endpoint
});

export default cmAPI;